/* DSL Cart-recovery on back-button — toon banner als user terugkomt en cart leeg is maar er was een snapshot */
(function(){
  if (!window.DSL_CART_PERSIST) return;
  if (location.pathname !== "/" && !/cart$/.test(location.pathname)) return;
  fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
    if (c.item_count > 0) return;
    var snap = window.DSL_CART_PERSIST.load();
    if (!snap || !snap.items || !snap.items.length) return;
    if (window.DSL_BANNER) {
      window.DSL_BANNER.show({
        text: "Je had nog " + snap.items.length + " producten in je winkelwagen. <a href=\"#\" data-restore-cart>Herstel</a>",
        variant: "info", duration: 15000
      });
    }
  });
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-restore-cart]")) return;
    e.preventDefault();
    var snap = window.DSL_CART_PERSIST.load();
    if (!snap || !snap.items) return;
    var items = snap.items.map(function(i){ return {id: i.variant_id, quantity: i.quantity}; });
    fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({items: items})}).then(function(){
      location.href = "/cart";
    });
    if (window.DSL_AB) window.DSL_AB.track("cart_recovered", {count: items.length});
  });
})();